import { Map as ImmutableMap } from 'immutable';
import { handleActions } from 'flux-actions';
import { AlertActionTypes } from '../actions/AlertActions';
import Alert from '../records/Alert';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const initialState = ImmutableMap();
const PhoneNumberErrors = ['EMPTY_INFO_ERROR', 'LIMIT_EXCEEDED', 'COUNTRY_CODE_ERROR', 'UNKNOWN_REGION', 'UNREACHABLE_NUMBER', 'PARSING_ERROR'];
export const getAlertSeverity = action => {
  const alertMessageKey = action.payload.alertMessageKey;
  if (PhoneNumberErrors.includes(alertMessageKey)) {
    return 'danger';
  }
  const split = alertMessageKey.split('_');
  const requestSuffix = split[split.length - 1];
  switch (requestSuffix) {
    case 'SUCCESS':
      return 'success';
    case 'FAILURE':
      return 'danger';
    default:
      return 'info';
  }
};
const getAlertTitle = severity => {
  if (severity === 'success') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "userPreferences.alerts.success"
    });
  } else if (severity === 'danger') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "userPreferences.alerts.error"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "userPreferences.alerts.info"
  });
};
const getHelpLinkMaybe = action => action.payload.helpUrl ? /*#__PURE__*/_jsxs("span", {
  children: [' ', /*#__PURE__*/_jsx(KnowledgeBaseButton, {
    url: action.payload.helpUrl
  })]
}) : null;
export const handleCreateActiveAlert = (state, action) => {
  const alertMessageKey = action.payload.alertMessageKey;
  const alertSeverity = getAlertSeverity(action);
  if (I18n.lookup(`userPreferences.alerts.${alertMessageKey}.title`)) {
    return state.set(alertMessageKey, new Alert({
      id: alertMessageKey,
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'Element' is not assignable to type 'undefine... Remove this comment to see the full error message
      message: /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: `userPreferences.alerts.${alertMessageKey}.message`,
          options: {
            data: action.payload.props
          }
        }), getHelpLinkMaybe(action)]
      }),
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'undefined... Remove this comment to see the full error message
      type: alertSeverity,
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'Element' is not assignable to type 'undefine... Remove this comment to see the full error message
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `userPreferences.alerts.${alertMessageKey}.title`,
        options: {
          data: action.payload.props
        }
      })
    }));
  }
  return state.set(alertMessageKey, new Alert({
    id: alertMessageKey,
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'Element' is not assignable to type 'undefine... Remove this comment to see the full error message
    message: /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: `userPreferences.alerts.${alertMessageKey}`,
        options: {
          data: action.payload.props
        }
      }), getHelpLinkMaybe(action)]
    }),
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'undefined... Remove this comment to see the full error message
    type: alertSeverity,
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'Element' is not assignable to type 'undefine... Remove this comment to see the full error message
    titleText: getAlertTitle(alertSeverity)
  }));
};
export default handleActions({
  [AlertActionTypes.CREATE_AUTOMATIC_DISMISSIBLE_ALERT](state, action) {
    return handleCreateActiveAlert(state, action);
  },
  [AlertActionTypes.CREATE_DISMISSIBLE_ALERT](state, action) {
    return handleCreateActiveAlert(state, action);
  },
  [AlertActionTypes.CLEAR_ALERT](state, action) {
    const alertId = action.payload;
    return state.delete(alertId);
  }
}, initialState);